import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MediasService } from 'src/app/services';
import { convertDateToStringQuery, removeEmptyQuery, sleep } from 'src/app/helpers';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';

@Component({
  selector: 'app-media-list',
  templateUrl: './media-list.component.html',
  styleUrls: ['./media-list.component.scss']
})
export class MediaListComponent implements OnInit, OnDestroy {
  constructor(
    private mediaService: MediasService,
    private notification: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
  ) { }

  unsubscribe$ = new Subject<void>();

  page = 1;
  pageSize = 10;
  data = []

  // ================================list==================================//
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  total: number;
  loading: Boolean = true;
  listOfDisplayData: any[] = [];
  listOfAllData: any[] = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  ids: any[] = [];
  isShow: Boolean;

  // ============================search=============================//
  keyword: string;
  status: number;
  send_type: number;
  begin_at: Date;
  end_at: Date;
  statuses: any[] = [
    { name: 'Chờ duyệt', id: 0 },
    { name: 'Đã duyệt', id: 1 },
    { name: 'Từ chối', id: 2 },
    { name: 'Đã gửi', id: 3 },
    { name: 'Đang xử lý tin nhắn', id: -1 },
    { name: 'Gửi lỗi', id: -2 },
  ];
  send_types: any[] = [
    { name: 'Tin nhắn InApp', id: 1 },
    { name: 'Thông báo', id: 2 },
  ];

  delayTimer: any;

  ranges = { Today: [new Date(), new Date()] };
  result: Date[] = [];
  // ==============================output====================================//
  dataDelete = {
    label: 'Xác nhận xóa truyền thông',
    value: '<p>Bạn có chắc chắn muốn xoá truyền thông này?</p>'
  };

  // ===============================actions=================================//
  @ViewChild('deleteMedias', { static: true }) deleteMedias;
  action: any;

  openMessage(type: string, title: string, content: any) {
    return this.notification.create(
      type,
      title,
      content
    );
  }

  currentPageDataChange($event: any[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(data?): void {
    if (data) {
      console.log('data', data)
      const index = this.data.findIndex(z => z.id === data.id);
      const brandName = data.name;
      const campaignType = data.name;
      const id = data.id;
      // const customerGroupId = data.customerGroups.map(z => z.id);
      // const enterpriseId = data.enterprise.id;
      index === -1 ? this.data.push({brandName, campaignType, id}) : this.data.splice(index, 1);
      console.log(this.data)
    }

    this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item.id]);
    this.isIndeterminate = this.listOfDisplayData.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      if (value) {
        this.ids.push(key);
      }
    }
    if (this.ids.length > 0) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
    this.data = this.listOfDisplayData.map(data => {
      const brandName = data.name;
      const campaignType = data.name;
      const id = data.id;
      // const enterpriseId = data.enterprise.id;
      return {brandName , campaignType , id};
    });
  }

  async loadData(ms = 0) {
    const query: any = {
      keyword: this.keyword ? this.keyword.trim() : null,
      status: this.status,
      send_type: this.send_type,
      begin_at: this.begin_at ? convertDateToStringQuery(this.begin_at) : null,
      end_at: this.end_at ? convertDateToStringQuery(this.end_at) : null,
      page: this.page,
      page_size: this.pageSize,
    };

    removeEmptyQuery(query);
    await sleep(ms);

    this.loading = true;
    this.mediaService.getAll(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        this.loading = false;
        this.total = res.data.totalElement;
        this.listOfAllData = res.data.items;
        if (!res.data.items && this.page > 1) {
          this.page = this.page - 1;
          this.loadData();
          return;
        }
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        return;
      }
    );
  }
  clearPosParam() {
    // @ts-ignore
    this.location.replaceState(this.location.path().split('?')[0], '');
  }
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.name !== undefined) {
        this.clearPosParam();
        this.keyword = params.name;
      }
      window.scrollTo(0, 0);
      this.notification.config({
        nzPlacement: 'bottomRight'
      });
      this.loadData();
    });
  }
  search() {
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      this.page = 1;
      this.loadData();
    }, 300);
  }

  filterStatus($event: number) {
    this.status = $event;
    this.page = 1;
    this.loadData();
  }

  filterSendType($event: number) {
    this.send_type = $event;
    this.page = 1;
    this.loadData();
  }
  filterDate(result: Date[]): void {
    this.result = result;
    if (this.result.length == 0) {
      this.begin_at = null;
      this.end_at = null;
      this.page = 1;
      this.loadData();
    } else {
      this.begin_at = this.result[0];
      this.end_at = this.result[1];
      this.page = 1;
      this.loadData();
    }
  }

  resetData() {
    this.keyword = null;
    this.status = null;
    this.send_type = null;
    this.begin_at = null;
    this.end_at = null;
    this.result = [];
    this.page = 1;
    this.filterDate(this.result);
    this.loadData();
  }
  delete(id: any) {
    const body = {
      body: {
        campaignIds: id,
      },
    };

    this.mediaService.destroy(body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        if (res.code === 1) {
          this.mapOfCheckedId = {};
          this.openMessage('success', 'Thành công', 'Xóa truyền thông thành công');
          this.deleteMedias.handleCancel();


          this.loadData(500);
        }
        if (res.code !== 1) {


          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
        }
        this.deleteMedias.success();
      },
      (err) => {

        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.deleteMedias.success();
        return;
      },
    );
  }
  actionsButton() {
    if (this.action == 1) {
      this.deleteMedias.showModal();
    } else if (this.action == 2) {

      this.deleteMedias.showModal(this.dataDelete, this.ids);
    }
    this.action = null;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
